module.exports = __webpack_public_path__ + "img/05.baa5958a.jpg";